export const TRAVEL_CALCULATOR_PATH = '/calculator/travel';
export const TRAVEL_CONTRACT_SIGN_PATH = '/create-contract/travel';
export const CMTPL_CONTRACT_SIGN_PATH = '/create-contract/cmtpl';
export const CMTPL_CONTRACT_VIDEO_GUIDE_PATH = '/car-accident-video-guide';
export const PROPERTY_CONTRACT_SIGN_PATH = '/create-contract/property';
export const RECURRING_PATH = '/recurring-payment';
export const CONTRACTS_VALIDATION_PATH = '/contracts/validation';
export const RECURRING_SCHEDULE_PATH = '/recurring-payment/schedule';
export const RECURRING_PAYMENT_PATH = '/recurring-payment/payment';
export const CONTRACT_SUBSCRIPTION_PATH = '/contract-subscription';
export const CONTRACT_SUBSCRIPTION_ATTACH_CARD_PATH = '/contract-subscription/attach-card';
export const CONTRACT_SUBSCRIPTION_POLICY_PATH = '/contract-subscription/policy';
export const MEDICAL_COMPENSATION_PATH = '/create-claim/medical';
export const CASCO_COMPENSATION_PATH = '/create-claim/casco';
export const TRAVEL_COMPENSATION_PATH = '/create-claim/travel';
export const ACCIDENT_COMPENSATION_PATH = '/create-claim/accident';
export const PROPERTY_COMPENSATION_PATH = '/create-claim/property';
export const CLAIM_STATUS_PATH = '/claim-status';
export const ONCOCARE_CALCULATOR_PATH = '/calculator/oncocare';
export const ONCOCARE_CONTRACT_SIGN_PATH = '/create-contract/oncocare';
export const ROADCARE_CALCULATION_PATH = '/calculator/roadcare';
export const ROADCARE_CONTRACT_SIGN_PATH = '/create-contract/roadcare';
